function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _formatRangeToTime = function formatRangeToTime(range) {
  if (Array.isArray(range)) {
    return "".concat(_formatRangeToTime(range[0]), " - ").concat(_formatRangeToTime(range[1]));
  }
  var strVal = range && range > -1 ? "".concat(range).split('.') : null;
  if (!strVal) {
    return '00h00';
  }
  var minusDecimal = strVal[1] ? strVal[1] + (strVal[1].length === 1 ? '0' : '') : '00';
  var minute = parseInt(parseInt(minusDecimal, 10) * 60 / 100, 10);
  minute = (minute < 10 ? '0' : '') + minute;
  return "".concat(strVal[0], "h").concat(minute);
};
export { _formatRangeToTime as formatRangeToTime };
var _formatTimeToRange = function formatTimeToRange(time) {
  if (_typeof(time) === 'object') {
    if (time.min && time.min !== time.max) {
      // Plage horaire
      return [_formatTimeToRange(time.min), _formatTimeToRange(time.max)];
    }
    return _formatTimeToRange(time.max);
  }
  if (!time || typeof time !== 'string' || time.indexOf('h') === -1) {
    return -1;
  }
  var values = time && typeof time === 'string' ? time.split('h') : null;
  if (!values) {
    return 0;
  }
  var decimal = parseInt(values[1], 10) * 100 / 60;
  return parseFloat("".concat(values[0], ".").concat(decimal));
};
export { _formatTimeToRange as formatTimeToRange };
export var formatToDatabase = function formatToDatabase(range) {
  if (Array.isArray(range)) {
    return {
      min: _formatRangeToTime(range[0]),
      max: _formatRangeToTime(range[1]),
      mid: _formatRangeToTime(((range[1] + range[0]) / 2).toFixed(2))
    };
  }
  return {
    min: _formatRangeToTime(range),
    max: _formatRangeToTime(range),
    mid: _formatRangeToTime(range)
  };
};